import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { FBaseService, collection } from '../services/firebase/f-base.service';

export const classworkSessionSubjectGuard = async (route: ActivatedRouteSnapshot) => {
  const firebaseService = inject(FBaseService);
  const router = inject(Router);
  const subjectId = route.paramMap.get('subjectId');
  const classworkSessionId = route.paramMap.get('classworkSessionId');

  try {
    if (!subjectId || !classworkSessionId) {
      await router.navigateByUrl('/select-subject');
      return false;
    }

    const classworkSession = await firstValueFrom(
      firebaseService.getById(collection.classworkSessions, classworkSessionId)
    );
    if (classworkSession?.subjectId === subjectId) return true;

    await router.navigateByUrl('/select-subject');
    return false;
  } catch (error) {
    console.error('Classwork session subject guard error:', error);
    await router.navigateByUrl('/select-subject');
    return false;
  }
};
